import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
import Rellax from "rellax";
import AOS from "aos";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
require("./helpers/Timeline");
require('plyr');
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
// GDPR Custom System
// require ('./helpers/CookieConsent');
// Controllers
require("./helpers/newsletterController");
let mapGlobal;
// Define all actions
let Site = {
    // Plugins
    carousel: carouselWrapper,
    // Actions
    init: () => {
        Site.global();
    },
    transition: (response) => {
        Site.global();
        Site.scripts(response);
    },
    global: () => {
        Site.carousel();
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false,
        });
        Site.filters();
        Site.map();
        if ($(window).width() < 600) {
            $("[data-aos='fade-left']").attr("data-aos", "fade-up");
        }
        AOS.init({
            disable: 'mobile'
        });
        setTimeout(() => { AOS.refresh(); }, 500);
    },
    map: () => {
    },
    filters: () => {
    },
    scripts: (response) => {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
// barba.init({
//     views: [],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             // te.toggle().eventCallback("onComplete", () => {
//             gsap.to(current.container, {
//                 opacity: 0
//             }).eventCallback("onComplete", () => {
//                 done();
//             });
//             // });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             })
//             // te.toggle()
//             .eventCallback("onComplete", () => {
//                 // te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
$(document).ready(function () {
    Site.init();
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            // const posY = $(node).offset().top - $("#main-header").height();
            const posY = $(node).offset().top;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    let isNegative = $("#main-header").hasClass("negative");
    $("body").on("click", "#menu-switcher a.switcher", (e) => {
        e.preventDefault();
        $("#main-header").removeClass("negative");
        if (isNegative && $("#nav-main").hasClass("show-menu")) {
            $("#main-header").addClass("negative");
        }
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, [href^='#']", (e) => {
        if (!$(e.currentTarget).hasClass("no-goto")) {
            const elm = $(e.currentTarget).attr("href");
            if ($(elm).length) {
                const posY = $(elm).offset().top;
                $.scrollTo(posY, 400);
            }
        }
    });
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            $('#main-header').addClass('scrolled');
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    if ($('.rellax').length) {
        var rellax = new Rellax('.rellax');
    }
    if ($("#player").length) {
        const player = new Plyr('#player');
    }
    if ($("#map").length) {
        const apiKey = $("#map").attr("data-uid");
        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
            libraries: []
        });
        const mapOptions = {
            center: {
                lat: parseFloat($("#map").attr("data-lat")),
                lng: parseFloat($("#map").attr("data-lng"))
            },
            zoom: 12,
            mapTypeControl: false,
            fullscreenControl: false
        };
        loader
            .load()
            .then((google) => {
            let map = new google.maps.Map(document.getElementById("map"), mapOptions);
            let children = $('.plat').length;
            let markers = [];
            let markersArr = [];
            $('.place').each((k, v) => {
                let content = $(v).html();
                let elm = $(v);
                // content.find(".action").remove();
                if (!isNaN(parseFloat($(v).attr("data-lat"))) && !isNaN(parseFloat($(v).attr("data-lng")))) {
                    let latLng = { lat: parseFloat($(v).attr("data-lat")), lng: parseFloat($(v).attr("data-lng")) };
                    let marker = new google.maps.Marker({
                        position: latLng
                    });
                    marker.setMap(map);
                    markers.push(marker);
                    markersArr.push({
                        lat: parseFloat($(v).attr("data-lat")),
                        lng: parseFloat($(v).attr("data-lng")),
                        elm: elm
                    });
                    let infowindow = new google.maps.InfoWindow({
                        content: `<div class="pop-up-map">
                            <div class="image"><img src="${elm.attr("data-image")}" /></div>
                            <div class="content">${content}</div>
                        </div>`,
                    });
                    marker.addListener("click", (e) => {
                        infowindow.open({
                            anchor: marker,
                            map,
                            shouldFocus: false,
                        });
                    });
                }
                if (k == (children - 1)) {
                    const markerCluster = new MarkerClusterer({ map, markers });
                    // google.maps.event.addListener(map, 'bounds_changed', function() {
                    //     var bounds =  map.getBounds();
                    //     var ne = bounds.getNorthEast();
                    //     var sw = bounds.getSouthWest();
                    //     markersArr.forEach((v) => {
                    //         let element = v;
                    //         let inViewport = ((element.lat < ne.lat() && element.lat > sw.lat()) && (element.lng < ne.lng() && element.lng > sw.lng() ));
                    //         if (inViewport) element.elm.show();
                    //         else if (!inViewport) element.elm.hide();
                    //     });
                    // });
                }
            });
        })
            .catch(e => {
        });
    }
});
